import { ChangeEvent, useCallback, useRef, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { defaultWMS1031_R01HeaderDto, WMS1031_R01DetailDto, WMS1031_R01HeaderDto } from "./Dto_WMS1031_R01";
import { useWMS1031_R01Store } from "./Store_WMS1031_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";
import { handleKeyDown, syntheticEvent } from "src/utils/commonForm/commonFormUtils";
import { AddressForm } from "src/components/common/form/address/AddressForm";



interface Props {
	defaultWMS1031_R01HeaderRow: WMS1031_R01HeaderDto;
	handleDetailInfoCode: (headerData: WMS1031_R01HeaderDto) => void;
	handleFetchDetailList: (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => void;
}

export const Info_WMS1031_R01 = (props: Props) => {

	const {
		defaultWMS1031_R01HeaderRow,
		handleDetailInfoCode, handleFetchDetailList
	} = props;

	// 
	const { inoutClassList, inoutMethodList, wmsCdList, compCdList, warehouseCdList, wmsOutTypeCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { 
			WMS1031_R01DetailList, setWMS1031_R01DetailList, deletedWMS1031_R01DetailList,
			editWMS1031_R01, setEditWMS1031_R01,
			selectedWMS1031_R01,
			transportComplete, setTransportComplete,
			detailFetchTrigger, setDetailFetchTrigger,
			warehouseCdListToUseList,
	} = useWMS1031_R01Store();


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const addressHandleFoucsId = 'addressInput';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editWMS1031_R01?.customCd || '',
				customNm: editWMS1031_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editWMS1031_R01?.empNo || '',
				empNm: editWMS1031_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editWMS1031_R01,
		setEditData: setEditWMS1031_R01,
		defaultData: defaultWMS1031_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1031_R01'
	});

	// 출고일자 달력 팝업 상태
	const [salesPickerVisible, setSalesPickerVisible] = useState(false);
	const [salesPickerPos, setSalesPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const handleDateChange = useCallback((field: keyof WMS1031_R01HeaderDto, value: any) => {
		setEditWMS1031_R01({
			...defaultWMS1031_R01HeaderRow,
			...editWMS1031_R01,
			[field]: value
		});
	}, [editWMS1031_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		if(name === 'warehouseCd') {
			setDetailFetchTrigger(true);
		}

		let additionalUpdates = {};
		// 출고물류(logicCenter)가 변경될 때, 해당 물류의 첫 번째 창고로 warehouseCd 자동 세팅
		if (name === 'logicCenter') {
			const availableWarehouses = warehouseCdListToUseList(value);
			additionalUpdates = {
				warehouseCd: availableWarehouses[0]?.warehouseCd || ''
			};
		}

		setEditWMS1031_R01({
			...defaultWMS1031_R01HeaderRow,
			...editWMS1031_R01,
			[name]: value,
			...additionalUpdates
		});
	}, [editWMS1031_R01, defaultWMS1031_R01HeaderRow, warehouseCdListToUseList, setDetailFetchTrigger]);

	const handleAddressSearchClick = () => {
		setAddressModalProps({
			onSelect: (data: AddressJusoDto) => {
				setEditWMS1031_R01({
					...defaultWMS1031_R01HeaderRow,
					...editWMS1031_R01,
					post: data.zipNo,
					address: data.roadAddr,
				})
				setAddressModalProps(undefined);
				handleKeyDown(syntheticEvent(addressHandleFoucsId), 'focus');
			},
			handleFoucsId: addressHandleFoucsId // 주소 검색 후 입력 포커스 이동을 위한 아이디
		})
	}

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				<InputForm title="출고지시번호" value={editWMS1031_R01?.wmsOrderNo || ""} 
					editable={false}
					name="wmsOrderNo" 
					onChange={handleChange} />
				<BRDiv />
				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editWMS1031_R01?.compCd}
					data={compCdList}
					editable={!transportComplete}
					onChange={handleChange}
				/>
				<SingleDateForm
					title="출고일자"
					value={editWMS1031_R01?.orderDt ? new Date(editWMS1031_R01.orderDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('orderDt', formatDate(value))}
					editable={true}
					visible={salesPickerVisible}				setVisible={setSalesPickerVisible}
					onChange={handleChange}
					pickerPos={salesPickerPos}						setPickerPos={setSalesPickerPos}
				/>
				<BRDiv />
				<DropDownForm
					title="출고구분"
					name="inoutClass"
					initLabelLess={true}
					value={editWMS1031_R01?.inoutClass}
					data={inoutClassList}
					editable={false}
					onChange={handleChange}
				/>
				<BRDiv />

				
				<DropDownForm<SysCodeDto> 
						title="출고물류"
						data={wmsCdList}
						value={editWMS1031_R01?.logicCenter || ""}
						name="logicCenter" 
						editable={false}
						initLabelLess={editWMS1031_R01?.closeTag === 'N'}
						onChange={handleChange} />
				<DropDownForm
					title="출고창고"
					name="warehouseCd"
					initLabelLess={true}
					value={editWMS1031_R01?.warehouseCd}
					data={warehouseCdListToUseList(editWMS1031_R01?.logicCenter || '')}
					editable={true}
					onChange={handleChange}
				/>
				<BRDiv />

				<CodeForm
					label="거래처"
					value={editWMS1031_R01?.customCd || ""}
					custNmValue={editWMS1031_R01?.customNm || ""}
					editable={false}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
				<CodeForm
					label="출고담당"
					value={editWMS1031_R01?.empNo || ""}
					custNmValue={editWMS1031_R01?.empNm || ""}
					editable={!transportComplete}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<BRDiv />

				
				<InputForm	title="전화번호" 
						value={editWMS1031_R01?.telNo || ""} 
						editable={!transportComplete} 
						name="telNo" 
						onChange={handleChange}
					/>
				<InputForm	title="팩스번호" 
						value={editWMS1031_R01?.faxNo || ""} 
						editable={!transportComplete} 
						name="faxNo" 
						onChange={handleChange}
					/>
				<BRDiv />
				<InputForm 
					title="e-mail" 
					value={editWMS1031_R01?.email || ""} 
					editable={!transportComplete} 
					name="email" 
					onChange={handleChange}
				/>
				<BRDiv />

				<AddressForm
					post={editWMS1031_R01?.post || ""}
					address={editWMS1031_R01?.address || ""}
					detailAddress={editWMS1031_R01?.otherAddress || ""}
					editable={!transportComplete}
					handleFoucsId={addressHandleFoucsId}
					onChange={handleChange}
					onSearchClick={handleAddressSearchClick}
				/>
				<BRDiv />

				<DropDownForm
					title="배송방법"
					name="inoutMethod"
					editable={!transportComplete}
					initLabelLess={editWMS1031_R01?.closeTag === 'N'}
					value={editWMS1031_R01?.inoutClass}
					data={inoutMethodList}
					onChange={handleChange}
				/>
				<BRDiv />
				<InputForm
					title="비고"
					value={editWMS1031_R01?.remark || ""}
					name="remark"
					editable={!transportComplete}
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
		</div>
	)
}